[
  {
    "code": "MW-C",
    "name": "Central"
  },
  {
    "code": "MW-N",
    "name": "Northern"
  },
  {
    "code": "MW-S",
    "name": "Southern"
  }
]